export default __webpack_public_path__ + "static/media/vu-center-2.4fb70429.png";